module.exports = __webpack_public_path__ + "static/media/imagen_web_1.52deb514.jpeg";